import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Container } from '../../layout/Container'
import { ChevronRight } from 'lucide-react'

export function HowWeWorkHero() {
  const { t } = useTranslation()

  return (
    <section className="relative flex min-h-[70vh] items-center overflow-hidden border-b border-border">
      <div className="absolute inset-0 bg-grid opacity-70" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-bg/50 to-bg" />

      <Container size="narrow" className="relative z-10 py-24 text-center">
        <motion.nav
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="flex items-center justify-center gap-2 text-sm text-text-secondary"
          aria-label="Breadcrumb"
        >
          <Link to="/" className="transition-colors hover:text-text-primary">
            {t('howWeWorkPage.breadcrumb.home')}
          </Link>
          <ChevronRight className="h-4 w-4" />
          <span className="text-text-primary">{t('howWeWorkPage.breadcrumb.current')}</span>
        </motion.nav>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="mt-8 text-4xl font-semibold tracking-tight text-text-primary sm:text-5xl md:text-6xl"
        >
          {t('howWeWorkPage.hero.headline')}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mx-auto mt-6 max-w-2xl text-lg text-text-secondary md:text-xl"
        >
          {t('howWeWorkPage.hero.subheadline')}
        </motion.p>
      </Container>
    </section>
  )
}
